import { render, staticRenderFns } from "./tab-multiselect.vue?vue&type=template&id=768c36ba"
import script from "./tab-multiselect.vue?vue&type=script&lang=js"
export * from "./tab-multiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports